var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/header/search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8472184,24.1180797 L20.9583295,19.2232975 C20.7999664,19.0610045 20.6236432,18.9173126 20.4327739,18.795004 L19.2105517,17.9506541 L19.2105517,17.9506541 C21.7245699,14.8361786 21.747917,10.3934268 19.2667709,7.25263782 C16.7856248,4.11184886 12.4621653,3.11125118 8.85600696,4.8432279 C5.24984866,6.57520462 3.32341996,10.5775177 4.21722303,14.4806806 C5.11102611,18.3838436 8.58651861,21.146162 12.5861073,21.1322625 C14.527053,21.1328279 16.4105079,20.4726084 17.9272184,19.2600084 L17.9272184,19.2600084 L18.843885,20.4837039 C18.9526138,20.6412982 19.0753344,20.7887404 19.2105517,20.9242343 L24.0994406,25.8190165 C24.2141868,25.934847 24.3703843,26 24.5333295,26 C24.6962746,26 24.8524721,25.934847 24.9672184,25.8190165 L25.8227739,24.9624296 C26.0547899,24.7326609 26.0655521,24.3609177 25.8472184,24.1180797 Z M12.5861073,18.6848714 C9.21103379,18.6848714 6.47499615,15.9455357 6.47499615,12.5663937 C6.47499615,9.18725181 9.21103379,6.44791603 12.5861073,6.44791603 C15.9611807,6.44791603 18.6972184,9.18725181 18.6972184,12.5663937 C18.6972184,14.1891149 18.053371,15.7453737 16.9073154,16.8928108 C15.7612597,18.040248 14.2068747,18.6848714 12.5861073,18.6848714 Z",
    id: "search"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.07f886be.svg";
export { ForwardRef as ReactComponent };